export const stateId = ({ lang, seed, level, secret }) => `${ lang }/${ seed }/${ level }/${ secret }`;


// WEBPACK FOOTER //
// ./src/helpers/id.js